export default "__VITE_ASSET__Bn248V2m__"